import { render, staticRenderFns } from "./EnergyVsProduction.vue?vue&type=template&id=3b2f9e53&"
import script from "./EnergyVsProduction.vue?vue&type=script&lang=js&"
export * from "./EnergyVsProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports